<script lang="ts" setup>
import { ref } from 'vue';
import { getRegistrationUrl } from '../utils/registration';
import { useAppStore } from '../stores/app';
import { getMenus } from '../utils/menu';

defineOptions({
  name: 'PageMenu',
});

const { config } = useAppStore();

const hamburger = defineModel<boolean>('hamburger');
const flEl = ref<HTMLElement>();
let isAnimating = false;
const menus = getMenus(config);

const slideUp = (element: HTMLElement) => {
  if (isAnimating) {
    return;
  }

  isAnimating = true;

  element.style.height = element.scrollHeight + 'px';
  element.style.height = '0px';

  setTimeout(() => {
    element.style.display = 'none';
    isAnimating = false;
  }, 300);
}

const slideDown = (element: HTMLElement) => {
  if (isAnimating) {
    return;
  }

  isAnimating = true;

  element.style.display = 'block';

  const height = element.scrollHeight + 'px';

  element.style.height = '0px';
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  element.offsetHeight;

  setTimeout(() => {
    element.style.height = height;
  }, 0);

  setTimeout(() => {
    isAnimating = false;
  }, 300);
}

const slideToggle = (element: HTMLElement) => {
  if (window.getComputedStyle(element).display === 'none') {
    slideDown(element);
  }
  else {
    slideUp(element);
  }
}

const handleClick = () => {
  if (isAnimating) {
    return;
  }

  const el = flEl.value;

  if (!el) {
    return;
  }

  if (window.getComputedStyle(el).display === 'none') {
    return;
  }

  const siblings = Array.from(el.parentElement?.parentElement?.children ?? []).filter(child => child !== el.parentElement);

  siblings.forEach(sibling => {
    const subMenus = sibling.querySelectorAll<HTMLElement>('.sub-menu');
    subMenus.forEach(subMenu => {
      slideUp(subMenu);
    });

    const flIcons = sibling.querySelectorAll('.fl');
    flIcons.forEach(flIcon => {
      flIcon.classList.add('flaticon-plus');
      flIcon.textContent = '+';
    });
  });

  if (el.classList.contains('flaticon-plus')) {
    el.classList.remove('flaticon-plus');
    el.classList.add('flaticon-minus');
    el.textContent = '-';
  }
  else {
    el.classList.remove('flaticon-minus');
    el.classList.add('flaticon-plus');
    el.textContent = '+';
  }

  const subMenu = el.nextElementSibling as HTMLElement;
  if (subMenu && subMenu.classList.contains('sub-menu')) {
    slideToggle(subMenu);
  }
};
</script>

<template>
  <!-- eslint-disable-next-line @unocss/order -->
  <div class="col-xl-7 col-sm-6 col-lg-8 col-md-8 col-xs-6">
    <nav class="main-nav" :class="{ 'slidenav': hamburger }">
      <div class="d-xl-none inner-logo">
        <RouterLink to="/"><img src="../assets/images/logo-v2.png" alt="logo" class="h-56 w-171 object-contain"></RouterLink>
      </div>
      <ul>
        <li v-for="(menu, index) in menus" :key="index">
          <template v-if="menu.isRouter">
            <RouterLink :to="menu.path" :class="{ 'active': menu.getActive?.($route) }" @click="hamburger = false">
              {{ menu.name }} <span>0{{ index + 1 }}</span>
            </RouterLink>
          </template>
          <template v-else>
            <a :href="menu.path" target="_blank">
              {{ menu.name }} <span>0{{ index + 1 }}</span>
            </a>
          </template>
        </li>

        <li class="has-child-menu">
          <a href="javascript:;" @click="handleClick">往届大会</a>
          <i class="fl flaticon-plus" ref="flEl" @click="handleClick">+</i>
          <ul class="sub-menu">
            <li><a href="https://www.openatom.cn/summit/2023/index/main/" target="_blank">2023 开放原子全球开源峰会</a></li>
            <li><a href="https://www.openatom.cn/conference/2024/index/main/" target="_blank">2024 开放原子开源生态大会</a></li>
          </ul>
        </li>
      </ul>

      <div class="d-xl-none inner-btn">
        <a :href="getRegistrationUrl()" class="primary-btn-fill" target="_blank">报名</a>
      </div>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
</style>
